import { authAPI } from './apiService'
import { Layer } from './models'

const URL = '/obj-imports'

export const GetStepName = (v: number) => {
  switch (v) {
    case 0:
      return 'UNKNOWN'
    case 1:
      return 'Сопоставление столбцов'
    case 2:
      return 'Сопоставление значений'
    case 3:
      return 'Готов к импорту'
    case 4:
      return 'В очереди'
    case 5:
      return 'Импортируется'
    case 6:
      return 'Импорт завершен'
    case 7:
      return 'Ошибка'
    default:
      return `STEP: ${v}`
  }
}

export const GetStepColor = (v: number) => {
  switch (v) {
    case 1:
    case 2:
      return 'processing'
    case 3:
      return 'success'
    case 4:
    case 5:
      return 'warning'
    case 6:
      return 'default'
    case 7:
      return 'red'
    default:
      return 'default'
  }
}

export type ObjImport = {
  id: number;
  userId: number;
  filename: string;
  description: string;
  size: number;
  path: string;
  layerId: number;
  createdAt: Date;
  step: number;
  mapHeaders: { [k: string]: string };
  mapValues: { [k: number]: { [k: string]: number } };
  result: { [k: string]: number }
}

export const GetObjImportLogStatusName = (v: number) => {
  switch (v) {
    case 0:
      return 'Добавлено'
    case 1:
      return 'Обновлено'
    case 2:
      return 'Ошибка'
    case 3:
      return 'Пропущено'
    case 4:
      return 'Инфо'
    default:
      return `STATUS: ${v}`
  }
}

export const GetObjImportLogStatusColor = (v: number) => {
  switch (v) {
    case 0:
      return 'success'
    case 1:
      return 'blue'
    case 2:
      return 'red'
    case 3:
      return 'warning'
    case 4:
      return 'default'
    default:
      return 'default'
  }
}

export type ObjImportLog = {
  id: number;
  importId: number;
  level: number;
  status: number;
  message: string;
  details: { [k: string]: any };
  rowNumber: number | null;
  createdAt: Date;
}

export type ObjImportListResponse = {
  imports: ObjImport[];
}

export type ObjImportResponse = {
  id: number;
  objImport: ObjImport;
  layer: Layer;
  headers: string[];
  values: { [key: number]: { value: string, id: number | null } [] };
}

export type ObjImportStartResponse = {
  status: string;
  result: { create: number, error: number, update: number, skip: number }
}

export type ObjImportLogsResponse = {
  logs: ObjImportLog[];
  total: number;
}

const objImportsService = {
  list: () => authAPI
    .get<ObjImportListResponse>(URL)
    .then((response) => response.data),

  get: (id: number) => authAPI
    .get<ObjImportResponse>(`${URL}/${id}`)
    .then((response) => response.data),

  getLogs: (id: number, limit = 100, offset = 0) => authAPI
    .get<ObjImportLogsResponse>(`${URL}/logs/${id}`, { params: { limit, offset } })
    .then((response) => response.data),

  start: (id: number) => authAPI
    .post<ObjImportStartResponse>(`${URL}/start`, { id })
    .then((response) => response.data),

  updateMapHeaders: (id: number, headers: { [key: string]: number }) => authAPI
    .post<any>(`${URL}/update-map-headers`, { id, headers })
    .then((response) => response.data),

  updateDescription: (id: number, description: string) => authAPI
    .post<any>(`${URL}/update-description`, { id, description })
    .then((response) => response.data),

  updateMapValues: (id: number, values: { [key: number]: { [key: string]: number } }) => authAPI
    .post<any>(`${URL}/update-map-values`, { id, values })
    .then((response) => response.data)

}

export default objImportsService
